import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const ITEMS_PER_COLUMN = 6;

type Props = {
  leadsByConsultant: { consultant: string; count: number }[];
  activationsByConsultant: { 
    activations: number; 
    reactivations: number; 
    technicalConsultant: string;
  }[];
};

export function LeadsByConsultant({ 
  leadsByConsultant, 
  activationsByConsultant 
}: Props) {
  const getConsultantActivations = (consultantName: string) => {
    const consultant = activationsByConsultant.find(
      (activation) => activation.technicalConsultant === consultantName
    );
    return {
      activations: consultant?.activations || 0,
      reactivations: consultant?.reactivations || 0,
    };
  };

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle className="font-bold">Leads por Consultor</CardTitle>
      </CardHeader>
      <CardContent>
        {leadsByConsultant.length > 0 ? (
          <div
            className="grid gap-4"
            style={{
              gridAutoFlow: "column",
              gridTemplateRows: `repeat(${ITEMS_PER_COLUMN}, minmax(0, 1fr))`,
            }}
          >
            {leadsByConsultant.map((item, index) => {
              const { activations } = getConsultantActivations(item.consultant);
              
              return (
                <div 
                  key={`${item.consultant}-${index}`} 
                  className="flex center flex-col border rounded-lg hover:shadow-md transition-shadow h-[120px] h-[150px]"
                >
                  <p className="p-4 text-base sm:text-lg font-bold text-gray-500 text-center truncate" title={item.consultant}>
                    {item.consultant}
                  </p>
                  
                  <p className="text-2xl text-center">
                    {item.count}
                  </p>
                  
                  <div className="flex bottom-2 justify-between">
                    <span className="text-black font-bold px-2 py-1 rounded text-[20px]">
                      {activations}
                    </span>
                    <span className="text-black font-bold px-2 py-1 rounded text-[20px]">
                    {((activations / item.count) * 100).toFixed(2)}%
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-center text-gray-500 py-8">
            Nenhum lead por consultor encontrado.
          </p>
        )}
      </CardContent>
    </Card>
  );
}
